/** The Signal pages' addresses, read once: the site (meetmy.io) and the API behind it. */
export const SITE_NAME = 'Meetmy';
export const SITE_URL = process.env.NEXT_PUBLIC_WEB_URL || 'https://meetmy.io';
export const API_URL = process.env.NEXT_PUBLIC_API_BASE_URL || 'http://localhost:3000';
export const MCP_URL = `${SITE_URL}/mcp`;

/** The Signal landing stands at /mcp until Meta's App Review verdict, then takes `/`. */
export const SIGNAL_HOME = '/mcp';

export const pageUrl = (username: string) => `${SITE_URL}/${username}`;

/** The pages that wear Signal, not the site bar and its frame: one list, read by `SiteChrome`. */
export const SIGNAL_ROUTES = ['/mcp', '/new', '/home', '/connect', '/claude', '/chatgpt', '/oauth'];

export const isSignalRoute = (pathname: string) =>
  SIGNAL_ROUTES.some((route) => pathname === route || pathname.startsWith(`${route}/`));

/**
 * The connector's protocol endpoints are the backend's, served under meetmy.io (the issuer).
 * `/mcp` is also the Signal landing, so only a request that does not ask for HTML is forwarded:
 * the apps send `application/json, text/event-stream`, a browser sends `text/html`.
 */
export const connectorRewrites = (api: string) => [
  {
    source: '/mcp',
    missing: [{ type: 'header' as const, key: 'accept', value: '(.*)text/html(.*)' }],
    destination: `${api}/mcp`,
  },
  {
    source: '/oauth/:step(authorize|token|register|revoke)',
    destination: `${api}/oauth/:step`,
  },
  {
    source: '/.well-known/:doc(oauth-protected-resource|oauth-authorization-server)/:rest*',
    destination: `${api}/.well-known/:doc/:rest*`,
  },
];
